import React from "react";
import Reveal from "./Reveal";

/**
 * Editorial pull-quote — a single oversized line that breaks the rhythm
 * between two content sections. Borrowed from long-form NYT Magazine layouts.
 */
export default function PullQuote({
  quote,
  attribution,
  testId = "pull-quote",
  align = "left",
}) {
  return (
    <section
      className="relative border-t hairline"
      style={{ background: "var(--canvas-deep)" }}
      data-testid={testId}
    >
      <div className="container-edge py-10 md:py-16">
        <div className={align === "center" ? "max-w-[1040px] mx-auto text-center" : "max-w-[1040px]"}>
          <Reveal>
            <span
              className="font-display block leading-none mb-6"
              style={{
                fontWeight: 400,
                fontSize: "clamp(64px, 8vw, 120px)",
                color: "var(--accent-gold)",
                opacity: 0.6,
              }}
              aria-hidden="true"
            >
              &ldquo;
            </span>
          </Reveal>
          <Reveal delay={120}>
            <p
              className="font-display italic tracking-tight leading-[1.08]"
              style={{
                fontWeight: 400,
                fontSize: "clamp(28px, 4.4vw, 56px)",
                color: "var(--ink)",
              }}
            >
              {quote}
            </p>
          </Reveal>
          {attribution && (
            <Reveal delay={220}>
              <p
                className="mt-8 font-mono text-[11px]"
                style={{ color: "var(--ink-tertiary)", letterSpacing: "0.18em" }}
              >
                {attribution}
              </p>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
